import { types } from 'mobx-state-tree';

const ExternalOrderData = types.model('OrderData', {
  trackingUrl: types.maybe(types.string),
  purchaseDate: types.maybe(types.string),
  externalOrderId: types.maybe(types.string),
  sourceItemId: types.maybe(types.string),
  quantity: types.number,
  sourcePrice: types.number,
  orderStatus: types.maybe(types.string),
  totalCharge: types.number,
  fee: types.number,
  buyerInfo: types.maybe(types.string),
  sourceOrderId: types.maybe(types.string),
  trackingNumber: types.maybe(types.string),
  carrier: types.maybe(types.string),
  expectedDelivery: types.maybe(types.string),
  failureReason: types.maybe(types.string),
  orderType: types.maybe(types.string),
  pdfUrl: types.maybe(types.string),
  returnCheckState: types.maybe(types.string),
  LostOrderState:types.maybe(types.string),
});

export default ExternalOrderData;
